import React from 'react';
import styled from 'styled-components';

interface ShapePreviewProps {
  shape: string;
  color: string;
}

export const ShapePreview: React.FC<ShapePreviewProps> = ({ shape, color }) => {
  // Sample QR code pattern for preview (4x4 section with random data patterns)
  const pattern = [
    [1, 1, 0, 1],
    [0, 1, 1, 0],
    [1, 0, 1, 1],
    [1, 1, 0, 1],
  ];

  const generateDotPath = (x: number, y: number, size: number) => {
    switch (shape) {
      case 'shape-circle':
        const radius = size / 2;
        return `M ${x + radius} ${y + radius} m -${radius} 0 a ${radius} ${radius} 0 1 0 ${size} 0 a ${radius} ${radius} 0 1 0 -${size} 0`;
      
      case 'shape-diamond':
        return `M ${x + size/2} ${y} L ${x + size} ${y + size/2} L ${x + size/2} ${y + size} L ${x} ${y + size/2} Z`;
      
      case 'shape-hexagon':
        const h = size/2;
        return `M ${x + h} ${y} l ${h} ${h} l 0 ${h} l -${h} ${h} l -${h} -${h} l 0 -${h} Z`;
      
      case 'shape-star':
        const points = [];
        for (let i = 0; i < 5; i++) {
          const angle = (i * 4 * Math.PI) / 5;
          points.push(`${x + size/2 + size/2 * Math.cos(angle)} ${y + size/2 + size/2 * Math.sin(angle)}`);
        }
        return `M ${points.join(' L ')} Z`;
      
      case 'shape-square':
      default:
        // Make squares slightly larger to ensure overlap
        const overlap = 0.5;
        return `M ${x} ${y} h ${size + overlap} v ${size + overlap} h -${size + overlap} Z`;
    }
  };

  const cellSize = 15;
  const gap = shape === 'shape-square' ? 0 : 1;
  const totalSize = (cellSize * 4) + (gap * 3);

  const paths: string[] = [];
  pattern.forEach((row, rowIndex) => {
    row.forEach((cell, colIndex) => {
      if (cell === 1) {
        const x = colIndex * (cellSize + gap);
        const y = rowIndex * (cellSize + gap);
        paths.push(generateDotPath(x, y, cellSize));
      }
    });
  });

  return (
    <PreviewContainer>
      <svg width={totalSize} height={totalSize} viewBox={`0 0 ${totalSize} ${totalSize}`}>
        {paths.map((path, index) => (
          <path key={index} d={path} fill={color} />
        ))}
      </svg>
    </PreviewContainer>
  );
};

const PreviewContainer = styled.div`
  width: 80px;
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: white;
  border-radius: 8px;
  padding: 8px;

  svg {
    width: 100%;
    height: 100%;
  }
`; 